<template lang="html">
  <div class="newslist">
    <v-expansion-panels>
      <v-expansion-panel
        v-for="(newsitem,i) in news"
        :key="i"
      >
        <v-expansion-panel-header>
          {{newsitem.full_title}}
          <v-spacer></v-spacer>
          <div class="text-right">
            <v-btn @click="updateNews(newsitem.id)" class="error" v-if="permToUpdateNews">UPDATE</v-btn>
          </div>

        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="image" v-if="newsitem.image">
            <v-img  :src="newsitem.image"></v-img>
          </div>
          <div class="content">
            {{newsitem.content}}
          </div>
          <div v-if="newsitem.document_link || newsitem.social_link" class="links">
            <div class="document-link mb-2" v-if="newsitem.document_link">
              <a :href="newsitem.document_link" target="_blank">
                  <v-icon>mdi-folder</v-icon>
                A cikkhez ezek a dokumentumok tartoznak
              </a>
            </div>
            <div class="social-link" v-if="newsitem.social_link">
              <a :href="newsitem.social_link" target="_blank">
                <v-icon>mdi-facebook</v-icon>
                A cikkhez kapcsolódó facebook-post
              </a>
            </div>
          </div>


        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: ['news'],
  computed: {
    permToUpdateNews(){
      return this.$store.getters.hasPermissionToChangeNewsitem
    }
  },
  methods: {
    updateNews(id){
      this.$router.push(`/administration/updatenews/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.newslist{
  width: 95%;
  max-width: 800px;
  margin: 0 auto;
  padding-bottom: 50px;

  .theme--light.v-expansion-panels .v-expansion-panel{
    background: transparent;
    margin-top: 15px;
  }

  .v-expansion-panel-header{
    font-weight: bold;
  }

  .image{
      max-width: 400px;
      width: 90%;
      margin: 0 auto;
  }
  .content{
    padding: 20px 0px;
    text-align: justify;
  }
}

.document-link,
.social-link{
  a:link,
  a:visited{
    text-decoration: none;
    color: 	rgb(139,69,19);
    cursor: pointer;
    text-decoration: none;

    &:hover{
      color: maroon;
    }
  }

  .mdi-folder{
    color: brown;
  }

  .mdi-facebook{
    color: rgb(66,103,178);
  }
}

</style>
